import type { EmphasizedText as EmphasizedTextType } from '@snapchat/mw-contentful-schema';
import { EmphasizedText as EmphasizedTextSDS } from '@snapchat/snap-design-system-marketing';

export const EmphasizedText: React.FC<EmphasizedTextType> = props => {
  const { text = '' } = props;

  return <EmphasizedTextSDS text={text} />;
};
